// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6XZX7","figure":"styles_figure__8kEgf","avatar":"styles_avatar__udTvq"};